<template>
  <main class="watch container">
    <div class="row">
      <div class="col-7">
        <watch-live></watch-live>
      </div>
      <div class="col-5">
        <b-tabs no-fade>
          <b-tab title="chat">
            <chat-thread class="chat-thread"></chat-thread>
            <chat-input></chat-input>
          </b-tab>

          <b-tab title="ban">
            <banned-watchers></banned-watchers>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </main>
</template>

<style scoped>
.chat-thread {
  height: 25rem;
}
</style>

<script>
import WatchLive from '@/components/live/WatchLive'
import ChatThread from '@/components/chat/ChatThread'
import ChatInput from '@/components/chat/ChatInput'
import BannedWatchers from '@/components/chat/BannedWatchers/'
// import l from '@/vendor/logger'

export default {
  name: 'Watch',

  created () {
    this.$store.dispatch('setMode', this.$route.params.mode.toUpperCase())
    this.$store.commit('setRid', this.$route.params.rid)
    this.$store.commit('room/setRoomType', 'WATCH')
    this.$store.dispatch('room/bindRoom')
    this.$store.dispatch('chat/bindChat')
    this.$store.dispatch('chatOption/bindBannedWatchers')
    this.$store.dispatch('chatOption/bindFilteringWords')
  },

  mounted () {
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {}
  },

  computed: {
  },

  methods: {
    unbind () {
      this.$store.dispatch('chat/unbindChat')
      this.$store.dispatch('room/unbindRoom')
      this.$store.dispatch('chatOption/unbindBannedWatchers')
      this.$store.dispatch('chatOption/unbindFilteringWords')
    }
  },

  components: {
    WatchLive,
    ChatThread,
    ChatInput,
    BannedWatchers
  }
}
</script>
